import { useBreadcrumbs } from "./BreadcrumbContext";
import { useLocation } from "wouter";

export function Breadcrumbs() {
    const { breadcrumbs } = useBreadcrumbs();
    const [, setLocation] = useLocation();

    return (
        <div className="px-4 md:px-6 pt-2 text-sm text-gray-600 flex items-center space-x-2 overflow-x-auto">

            <span
                className="cursor-pointer text-blue-600"
                onClick={() => {
                    window.location.href =
                        "https://bprm-ai-portal.workfinity.com/landing";
                }}
            >
                Introduction
            </span>

            <span>{">>"}</span>

            <span
                className="cursor-pointer text-blue-600"
                onClick={() => {
                    window.location.href =
                        "https://bprm-ai-portal.workfinity.com/hexagonDesign";
                }}
            >
                Dashboard
            </span>

            {breadcrumbs.map((item, index) => (
                <div key={index} className="flex items-center space-x-2">
                    <span>{">>"}</span>

                    {item.path ? (
                        <span
                            className="cursor-pointer text-blue-600"
                            onClick={() => setLocation(item.path!)}
                        >
                            {item.label}
                        </span>
                    ) : (
                        <span className="font-semibold text-gray-900">
                            {item.label}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
}